import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { Gallery } from 'shared/ui/gallery'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { GalleryImages } from 'shared/ui/image-carousel/styles.ts'

import s from './styles.module.scss'

const UmraTourGalleryPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { title, images } = useLocation().state as {
    title: string
    images: GalleryImages[]
  }

  const handleClickImage = (index: number) => {
    navigate(RoutingPaths.umrah.preview.path(index), {
      state: { title, images },
    })
  }

  if (!title || !images) {
    return (
      <div className={s.container}>
        <HeaderGoBack
          buttonWhite
          variant="grey"
          title=""
        />
        <div className={s.empty}>
          <p>{t('tours_block.empty_images')}</p>
        </div>
      </div>
    )
  }

  const galleryImages = useMemo(
    () =>
      images.map((item) => ({
        src: item.image,
      })),
    [images],
  )

  return (
    <div className={s.container}>
      <HeaderGoBack
        buttonWhite
        variant="grey"
        title={title}
      />

      <Gallery
        images={galleryImages}
        title={title}
        onClickImage={handleClickImage}
      />
    </div>
  )
}

export default UmraTourGalleryPage
